import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, NgModule } from '@angular/core';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import * as i1 from '@angular/cdk/a11y';

class XpoActionButton {
}
XpoActionButton.ɵfac = function XpoActionButton_Factory(t) { return new (t || XpoActionButton)(); };
XpoActionButton.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoActionButton, selectors: [["", "xpo-action-button", ""], ["", "xpoActionButton", ""]], hostAttrs: [1, "xpo-ActionButton"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoActionButton, [{
        type: Directive,
        args: [{
                selector: '[xpo-action-button], [xpoActionButton]',
                host: {
                    class: 'xpo-ActionButton',
                },
            }]
    }], null, null); })();

const _c0$1 = ["*"];
class XpoIconButtonGroup {
}
XpoIconButtonGroup.ɵfac = function XpoIconButtonGroup_Factory(t) { return new (t || XpoIconButtonGroup)(); };
XpoIconButtonGroup.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoIconButtonGroup, selectors: [["", "xpoIconButtonGroup", ""]], hostAttrs: [1, "xpo-ButtonGroup--icon"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoIconButtonGroup, [{
        type: Directive,
        args: [{
                selector: '[xpoIconButtonGroup]',
                host: { class: 'xpo-ButtonGroup--icon' },
            }]
    }], null, null); })();
class XpoButtonGroup {
}
XpoButtonGroup.ɵfac = function XpoButtonGroup_Factory(t) { return new (t || XpoButtonGroup)(); };
XpoButtonGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoButtonGroup, selectors: [["xpo-button-group"]], hostAttrs: [1, "xpo-ButtonGroup"], ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function XpoButtonGroup_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [".flex--stretch{flex:1}.xpo-ButtonGroup{display:block}.xpo-ButtonGroup>[class*=-button],.xpo-ButtonGroup button{margin-right:8px}.xpo-ButtonGroup>[class*=-button]:last-child,.xpo-ButtonGroup button:last-child{margin-right:0}.xpo-ButtonGroup--icon{align-items:center;display:inline-flex;height:36px;outline:1px solid #d8d8d8}.xpo-ButtonGroup--icon>[class*=-button]{border-radius:0;border-right:1px solid #d8d8d8;color:#6f6f6f;height:100%;margin-right:0}.xpo-ButtonGroup--icon>[class*=-button]:hover{color:#4a4a4a}.xpo-ButtonGroup--icon>[class*=-button]:last-child{border-right:none}.xpo-ButtonGroup--icon>[class*=-button]:disabled{background-color:#e6e6e6}.xpo-ButtonGroup--icon>[class*=-button] .mat-button-wrapper{width:100%}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoButtonGroup, [{
        type: Component,
        args: [{
                selector: 'xpo-button-group',
                templateUrl: './button-group.component.html',
                styleUrls: ['./button-group.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-ButtonGroup',
                },
            }]
    }], null, null); })();

class XpoButton {
}
XpoButton.ɵfac = function XpoButton_Factory(t) { return new (t || XpoButton)(); };
XpoButton.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoButton, selectors: [["", "xpo-button", ""], ["", "xpoButton", ""]], hostAttrs: [1, "xpo-Button"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoButton, [{
        type: Directive,
        args: [{
                selector: '[xpo-button], [xpoButton]',
                host: {
                    class: 'xpo-Button',
                },
            }]
    }], null, null); })();

class XpoLargeButton {
}
XpoLargeButton.ɵfac = function XpoLargeButton_Factory(t) { return new (t || XpoLargeButton)(); };
XpoLargeButton.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoLargeButton, selectors: [["", "xpo-large-button", ""], ["", "xpoLargeButton", ""]], hostAttrs: [1, "xpo-LargeButton"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoLargeButton, [{
        type: Directive,
        args: [{
                selector: '[xpo-large-button], [xpoLargeButton]',
                host: {
                    class: 'xpo-LargeButton',
                },
            }]
    }], null, null); })();

const _c0 = ["xpo-link", ""];
const _c1 = ["*"];
class XpoLink extends MatAnchor {
    constructor(focusMonitor, elementRef, animationMode) {
        super(focusMonitor, elementRef, animationMode);
        this.elementRef = elementRef;
        this.color = 'primary';
    }
    hasAttribute(value) {
        return this.elementRef.nativeElement.hasAttribute(value);
    }
}
XpoLink.ɵfac = function XpoLink_Factory(t) { return new (t || XpoLink)(i0.ɵɵdirectiveInject(i1.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(ANIMATION_MODULE_TYPE)); };
XpoLink.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoLink, selectors: [["a", "xpo-link", ""], ["a", "xpo-regular-link", ""]], hostAttrs: [1, "xpo-Link"], hostVars: 4, hostBindings: function XpoLink_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-Link--regular", ctx.hasAttribute("xpo-regular-link"))("xpo-Link--accent", ctx.color === "accent");
    } }, inputs: { color: "color" }, features: [i0.ɵɵInheritDefinitionFeature], attrs: _c0, ngContentSelectors: _c1, decls: 1, vars: 0, template: function XpoLink_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoLink, [{
        type: Component,
        args: [{
                selector: 'a[xpo-link], a[xpo-regular-link]',
                template: '<ng-content></ng-content>',
                host: {
                    class: 'xpo-Link',
                    '[class.xpo-Link--regular]': 'this.hasAttribute("xpo-regular-link")',
                    '[class.xpo-Link--accent]': 'color === "accent"',
                },
            }]
    }], function () { return [{ type: i1.FocusMonitor }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [ANIMATION_MODULE_TYPE]
            }] }]; }, { color: [{
            type: Input
        }] }); })();

class XpoSmallButton {
}
XpoSmallButton.ɵfac = function XpoSmallButton_Factory(t) { return new (t || XpoSmallButton)(); };
XpoSmallButton.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoSmallButton, selectors: [["", "xpo-small-button", ""], ["", "xpoSmallButton", ""]], hostAttrs: [1, "xpo-SmallButton"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoSmallButton, [{
        type: Directive,
        args: [{
                selector: '[xpo-small-button], [xpoSmallButton]',
                host: {
                    class: 'xpo-SmallButton',
                },
            }]
    }], null, null); })();

class XpoButtonModule {
}
XpoButtonModule.ɵfac = function XpoButtonModule_Factory(t) { return new (t || XpoButtonModule)(); };
XpoButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoButtonModule });
XpoButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule], MatButtonModule,
        MatButtonToggleModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [XpoButtonGroup, XpoButton, XpoLargeButton, XpoSmallButton, XpoLink, XpoIconButtonGroup, XpoActionButton],
                exports: [
                    XpoButtonGroup,
                    XpoButton,
                    XpoLargeButton,
                    XpoSmallButton,
                    MatButtonModule,
                    MatButtonToggleModule,
                    XpoLink,
                    XpoIconButtonGroup,
                    XpoActionButton,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoButtonModule, { declarations: [XpoButtonGroup, XpoButton, XpoLargeButton, XpoSmallButton, XpoLink, XpoIconButtonGroup, XpoActionButton], imports: [CommonModule], exports: [XpoButtonGroup,
        XpoButton,
        XpoLargeButton,
        XpoSmallButton,
        MatButtonModule,
        MatButtonToggleModule,
        XpoLink,
        XpoIconButtonGroup,
        XpoActionButton] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoActionButton, XpoButton, XpoButtonGroup, XpoButtonModule, XpoIconButtonGroup, XpoLargeButton, XpoLink, XpoSmallButton };
